import { library, dom, config } from '@fortawesome/fontawesome-svg-core';

import {
  faXTwitter, faLinkedinIn
} from '@fortawesome/free-brands-svg-icons';

import {
  faAngleLeft, faAngleRight
} from '@fortawesome/free-solid-svg-icons';

config.autoAddCss = false;
config.keepOriginalSource = false;
config.autoReplaceSvg = true;
config.observeMutations = true;

library.add(faXTwitter, faLinkedinIn, faAngleLeft, faAngleRight);
dom.watch();
